import React from 'react';

import { Icon, ListRow, Separator, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '../../features/navigation/SambaAutoLink';

type RecurringTransactionSetupProps = {
  subText?: string;
  setupUrl: string;
};

export const RecurringTransactionsSetup: React.FC<RecurringTransactionSetupProps> = ({ subText, setupUrl }) => (
  <SambaAutoLink to={setupUrl} css={{ color: 'text', _hover: { color: 'text' } }}>
    <Separator css={{ fullWidthWithInset: 'space.300' }} />
    <ListRow>
      <ListRow.LeadingAsset>
        <Icon name="ArrowCirclePlus" size="small" />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text>{subText ? 'Set up a recurring deposit.' : 'Automate your savings with a recurring transaction.'}</Text>
        {subText && (
          <Text variant="text50" color="text.weak">
            {subText}
          </Text>
        )}
      </ListRow.LeadingContent>
      <ListRow.TrailingAsset>
        <Icon name="CaretRight" size="small" />
      </ListRow.TrailingAsset>
    </ListRow>
  </SambaAutoLink>
);
